import { createSlice } from '@reduxjs/toolkit'

import {
	createActions,
	initialStateTemplate,
	reducers,
} from '.reducers/libraries/filters.template'

const initialState = {
	companyId: window.sessionStorage.getItem('libTalent_currentCompanyID'),
	name: '',
	...initialStateTemplate,
}

const libTalentFilters = createSlice({
	name: 'LIB/TALENTS/FILTERS',
	initialState,
	reducers: {
		...reducers,
		setName(state, { payload: name }) {
			state.name = name
		},
		setCity(state, { payload: city }) {
			state.city = city
			state.currentPage = 1
		},
	},
})

export const {
	setCurrentPage,
	setIsOpen,
	setPerPage,
	setOrder,
	setSortBy,
	setPublicLink,
	resetLastUpdate,
	setCompanyId,
	setTagFilter,
	setTagsFilter,
	resetTagsFilter,
	setInitialState,
	toggleFavorites,
	toggleAllFavorites,
	setSearchTerm,
	clearTags,
} = createActions(libTalentFilters.name)

export const { setName, setCity } = libTalentFilters.actions

export default libTalentFilters.reducer
